import { types } from 'mobx-state-tree';

export default types.model('Navigation', {
  mode: types.string,
  url: types.string,
  text: types.string,
});
